import ProjectModel from './ProjectModel'

const mapFilingTypePropertyNameToDesc = {
  provisionalFilings: 'provisional filed',
  nonprovisionalFilings: 'non-provisional filed',
  patentPendingFilings: 'pending',
  issuedFilings: 'granted'
}

export default class IntellectualPropertyModel extends ProjectModel {
  filings
  leadInventorName
  caseManagerName
  caseManagerEmail
  pdfFile

  constructor (obj) {
    super(obj)

    // Assume creation from JSON AJAX call
    const normalizedObj = IntellectualPropertyModel.normalizeFromJS(obj)

    this.filings = obj.filings
    this.leadInventorName = normalizedObj.leadInventorName
    this.caseManagerName = normalizedObj.caseManagerName
    this.caseManagerEmail = normalizedObj.caseManagerEmail
    this.pdfFile = normalizedObj.pdfFile
    this.provisionalFilings = normalizedObj.provisionalFilings
    this.nonprovisionalFilings = normalizedObj.nonprovisionalFilings
    this.patentPendingFilings = normalizedObj.patentPendingFilings
    this.issuedFilings = normalizedObj.issuedFilings
  }

  get description () {
    return Object.keys(mapFilingTypePropertyNameToDesc)
      .filter(propertyName => this[propertyName].length > 0)
      .map(propertyName => `${this[propertyName].length} ${mapFilingTypePropertyNameToDesc[propertyName]}`)
      .join('; ')
  }

  static normalizeFromJS (obj) {
    const filings = obj.filings.map(x => new PatentFiling(x))

    return {
      filings,
      leadInventorName: obj.lead_inventor_name,
      caseManagerName: obj.case_manager_name,
      caseManagerEmail: obj.case_manager_email,
      pdfFile: obj.pdf_file ? '/storage/' + obj.pdf_file : obj.pdf_file,
      provisionalFilings: filings.filter(x => x.type === 'provisional filed'),
      nonprovisionalFilings: filings.filter(x => x.type === 'non-provisional filed'),
      patentPendingFilings: filings.filter(x => x.type === 'patent pending'),
      issuedFilings: filings.filter(x => x.type === 'issued patent')
    }
  }

  static fromJS (obj) {
    return new IntellectualPropertyModel(obj)
  }
}

class PatentFiling {
  constructor (obj) {
    this.type = obj.type
    this.applicationNum = obj.application_num
    this.publicationNum = obj.publication_num
    this.patentNum = obj.patent_num
    this.dateFiled = obj.date_filed
    this.datePublished = obj.date_published
    this.dateIssued = obj.date_issued
  }

  get date () {
    const datePropertyName = PatentFiling.appropriateDateForType[this.type]
    return this[datePropertyName]
  }

  get num () {
    const numPropertyName = PatentFiling.appropriateNumberForType[this.type]
    return this[numPropertyName]
  }

  get url () {
    // provisional and non-provisional patents don't have a page on Google
    // Patents
    if (this.type === 'patent pending' || this.type === 'issued patent') {
      return `https://patents.google.com/patent/${this.num}/en`
    }
  }

  static appropriateDateForType = {
    'provisional filed': 'dateFiled',
    'non-provisional filed': 'dateFiled',
    'patent pending': 'datePublished',
    'issued patent': 'dateIssued'
  }

  static appropriateNumberForType = {
    'provisional filed': 'applicationNum',
    'non-provisional filed': 'applicationNum',
    'patent pending': 'publicationNum',
    'issued patent': 'patentNum'
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/IntellectualPropertyModel.js